module.exports = __webpack_public_path__ + "static/media/tourism.91bc3bb7.jpg";